import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { mergeOptions } from 'lib/utils/mergeProps';
import type { ReactNode } from 'react';
import { TrendingMenu } from './TrendingMenu';

export interface StandaloneTrendingMenuProps extends StandaloneComponentProps<typeof TrendingMenu> {
  headline?: ReactNode;
  tags?: {
    content?: ReactNode;
    url?: string;
  }[];
}

export const StandaloneTrendingMenu: StandaloneComponent<StandaloneTrendingMenuProps> = ({
  headline,
  tags,
  options,
}) => {
  const { $headline: headlineProps, $tag, ...baseProps } = options ?? {};

  if (!tags?.length) {
    return null;
  }

  return (
    <TrendingMenu {...baseProps}>
      {headline && <TrendingMenu.Headline {...headlineProps}>{headline}</TrendingMenu.Headline>}
      {tags?.map(({ content, url }, index) => (
        <TrendingMenu.Tag
          key={index}
          value={content}
          link={{ href: url || '' }}
          options={mergeOptions(
            {
              size: 'small',
            },
            $tag
          )}
        />
      ))}
    </TrendingMenu>
  );
};

export default StandaloneTrendingMenu;
